<template>
  <div
    class="modal fade"
    id="customPropertyListEditModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <form id="propertyListEditForm">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button type="button" class="close" @click="closeListEditModal()">
              ×
            </button>
            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.SM2500 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="form-group">
                  <div class="col-md-2">
                    <button
                      class="btn btn-raised btn-entry-actions"
                      v-if="!propertyListAddEnabled"
                      @click.prevent="showAddPropertyListInput()"
                    >
                      <i class="material-icons md-36">add_circle</i>
                      <br />
                      {{ lang.SM2501 }}
                    </button>
                    <button
                      class="btn btn-raised btn-warning btn-entry-actions"
                      v-else
                      @click.prevent="addNewPropertyListEntries()"
                    >
                      <i class="material-icons md-36">add_circle</i>
                      <br />
                      {{ lang.SM2501 }}
                    </button>
                  </div>
                  <div
                    class="col-md-10 text-left"
                    v-show="!propertyListAddEnabled"
                  >
                    <button
                      class="btn btn-raised btn-entry-actions"
                      @click.prevent="toggleSelectAllEntries()"
                    >
                      <i class="material-icons md-36">{{
                        allEntriesSelected() ? "remove_circle" : "check_circle"
                      }}</i>
                      <br />
                      {{ allEntriesSelected() ? lang.SM2503 : lang.SM2502 }}
                    </button>
                    <button
                      class="btn btn-raised btn-entry-actions"
                      :disabled="!isAnyEntrySelected()"
                      @click.prevent="removeSelectedEntries()"
                    >
                      <i class="material-icons md-36">delete</i>
                      <br />
                      {{ lang.SM2504 }}
                    </button>
                    <button
                      class="btn btn-raised btn-entry-actions"
                      :disabled="!isAnyEntrySelected()"
                      @click.prevent="toggleVisibilityOfSelectedEntries()"
                    >
                      <i class="material-icons md-36">{{
                        allSelectedEntriesVisible()
                          ? "visibility_off"
                          : "visibility"
                      }}</i>
                      <br />
                      {{
                        allSelectedEntriesVisible() ? lang.SM2505 : lang.SM2506
                      }}
                    </button>
                    <!-- <button
                      class="btn btn-raised btn-entry-actions"
                      :disabled="hasPropertyListError"
                      @click.prevent="sortPropertyValues(), isPropertyListDataDirty = true;"
                    >
                      <i class="material-icons md-36">swap_vert</i>
                      <br />Sort entries
                    </button>-->
                  </div>
                  <div class="col-md-10" v-show="propertyListAddEnabled">
                    <textarea
                      type="text"
                      class="form-control"
                      rows="5"
                      id="textareaPropertyList"
                      :placeholder="`${lang.SM2507} 1\n${lang.SM2507} 2\n${lang.SM2507} 3`"
                      v-model="propertyListAddData"
                    />
                  </div>
                </div>
                <div id="propertyListValuesTableContainer">
                  <table
                    class="table table-striped table-hover"
                    id="propertyListValuesTable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center col-md-10">{{ lang.SM2507 }}</th>
                        <th class="text-center col-md-2">{{ lang.SM2508 }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="button"
                        v-for="(entry, index) in propertyListData.Values"
                        :key="index"
                        @click="
                          (entry.selected = !entry.selected), $forceUpdate()
                        "
                        :class="{ info: entry.selected, error: entry.error }"
                      >
                        <td class="nopadding">
                          <div class="form-group nopadding">
                            <input
                              type="text"
                              class="form-control text-center nopadding"
                              readonly="true"
                              @blur="propertyListEntryChanged($event, index)"
                              @dblclick="editEntry"
                              @click="
                                $event.target.readOnly ||
                                  $event.stopPropagation()
                              "
                              @change="isPropertyListDataDirty = true"
                              @keydown.enter.prevent="$event.target.blur()"
                              v-model="entry.Value"
                            />
                          </div>
                        </td>
                        <td
                          class="nopadding"
                          id="actionButtonContainer"
                          @click.stop="isPropertyListDataDirty = true"
                        >
                          <button type="button" class="btn" @click="editEntry">
                            <i class="material-icons md-24">edit</i>
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="
                              (entry.Visible = !entry.Visible), $forceUpdate()
                            "
                          >
                            <i
                              class="material-icons md-24"
                              :class="{ 'text-grey': !entry.Visible }"
                              >{{
                                entry.Visible ? "visibility" : "visibility_off"
                              }}</i
                            >
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="removeEntry(index)"
                          >
                            <i class="material-icons md-24 text-red">clear</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default btn-close"
              @click="closeListEditModal()"
            >
              {{ lang.SM2509 }}
            </button>
            <button
              type="button"
              class="btn btn-raised btn-default"
              :class="{
                'btn-warning': isPropertyListDataDirty,
                'btn-success': !isPropertyListDataDirty,
              }"
              :disabled="hasPropertyListError || propertyListAddEnabled"
              @click="storePropertyListItems()"
            >
              {{ lang.SM2510 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomPropertyListEditModal",
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#customPropertyListEditModal").on("hide.bs.modal", (e) => {
      this.$emit("modalClosing");
    });
  },
  props: ["showModal", "listGuid"],
  watch: {
    showModal(newValue) {
      if (newValue) this.openListEditModal();
      else this.closeListEditModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      propertyListAddData: "",
      propertyListAddEnabled: false,
      propertyListData: {},
      isPropertyListDataDirty: false,
      hasPropertyListError: false,
      selectedListItems: [],
      lang: {
        SM2500: "Edit selection list",
        SM2501: "Add new entries",
        SM2502: "Select all",
        SM2503: "Unselect all",
        SM2504: "Remove selected",
        SM2505: "Hide selected",
        SM2506: "Show selected",
        SM2507: "Item",
        SM2508: "Actions",
        SM2509: "Close",
        SM2510: "Save",
        SM2511: "List update successful",
        SM2512: "List update failed",
        SM2513: "Empty values are not allowed",
        SM2514: "Value already exists",
      },
    };
  },
  methods: {
    openListEditModal() {
      this.propertyListAddData = "";
      this.propertyListAddEnabled = false;
      this.propertyListData = {};
      this.isPropertyListDataDirty = false;
      this.hasPropertyListError = false;
      this.selectedListItems = [];
      this.getPropertyListItems();
      $("#customPropertyListEditModal").modal("show");
    },
    closeListEditModal() {
      if (this.isPropertyListDataDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", () => {
          this.isPropertyListDataDirty = false;
          $("#customPropertyListEditModal").modal("hide");
        });
        return;
      }
      $("#customPropertyListEditModal").modal("hide");
    },
    showAddPropertyListInput() {
      this.propertyListAddEnabled = true;
      this.toggleSelectAllEntries(true);
      this.$nextTick(() => {
        $("#textareaPropertyList").focus();
      });
    },
    getPropertyListItems() {
      if (!this.listGuid) {
        //No list created yet
        return;
      }

      let queryString = `api/ShopperProperty/List/${this.listGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!data) {
            console.error("No property list data available");
          }
          this.propertyListData = data;
          this.sortPropertyValues();
        },
        error: () => {
          console.error(
            "Property list access failed in getPropertyListItems()"
          );
          this.globals.showErrorSnackbar("Property list access failed");
        },
      });
    },
    storePropertyListItems() {
      let method = this.listGuid ? "PUT" : "POST";
      let url = `api/ShopperProperty/List/${this.listGuid || ""}`;
      this.sortPropertyValues();
      let dataString = JSON.stringify(this.propertyListData);

      $.ajax({
        method: method,
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.SM2511);
          this.isPropertyListDataDirty = false;
          if (method === "POST")
            this.$emit("propertyListCreated", data.ListGuid);
          this.closeListEditModal();
        },
        error: () => {
          console.error(`Error on ${method} in storePropertyListItems()`);
          this.globals.showErrorSnackbar(this.lang.SM2512);
        },
      });
    },
    addNewPropertyListEntries() {
      this.propertyListAddEnabled = false;
      if (!this.propertyListAddData) return;

      let entries = _.split(this.propertyListAddData, "\n");
      this.propertyListAddData = "";
      if (!this.propertyListData.Values) this.propertyListData.Values = [];

      for (let entry of entries) {
        if (entry && !this.isEntryInList(entry))
          this.propertyListData.Values.push({ Value: entry, selected: true });
      }
      this.isPropertyListDataDirty = true;
      this.selectedListItems = [];
      this.sortPropertyValues();
    },
    isEntryInList(entry) {
      if (!this.propertyListData.Values) return false;
      return _.findIndex(this.propertyListData.Values, ["Value", entry]) > -1;
    },
    sortPropertyValues() {
      this.propertyListData.Values = _.sortBy(this.propertyListData.Values, [
        (val) => val.Value.toLowerCase(),
      ]);
    },
    toggleSelectAllEntries(clear) {
      let value = clear ? false : !this.allEntriesSelected();
      _.forEach(this.propertyListData.Values, (val) => {
        val.selected = value;
      });
      this.$forceUpdate();
    },
    isAnyEntrySelected() {
      if (!this.propertyListData.Values) return false;
      return _.findIndex(this.propertyListData.Values, ["selected", true]) > -1;
    },
    allEntriesSelected() {
      if (this.propertyListData.Values)
        for (let val of this.propertyListData.Values) {
          if (!val.selected) return false;
        }
      else return false;
      return true;
    },
    removeSelectedEntries() {
      if (this.propertyListData.Values) {
        _.remove(this.propertyListData.Values, (val) => !!val.selected);
        this.isPropertyListDataDirty = true;
        this.$forceUpdate();
      }
    },
    removeEntry(index) {
      _.pullAt(this.propertyListData.Values, index);
      this.$forceUpdate();
    },
    editEntry(e) {
      let input = $(e.target).closest("tr").find("input");
      if (!this.hasPropertyListError) input.prop("readonly", "");
      input.focus();
    },
    allSelectedEntriesVisible() {
      if (this.propertyListData.Values)
        for (let val of this.propertyListData.Values) {
          if (val.selected && !val.Visible) return false;
        }
      else return false;
      return true;
    },
    toggleVisibilityOfSelectedEntries() {
      let visible = !this.allSelectedEntriesVisible();
      this.propertyListData.Values.forEach((val) => {
        if (val.selected) val.Visible = visible;
      });
      this.isPropertyListDataDirty = true;
      this.$forceUpdate();
    },
    propertyListEntryChanged(e, index) {
      if (e.target.readOnly) return;

      let newValue = e.target.value;
      let values = this.propertyListData.Values;

      let onError = () => {
        values[index].error = true;
        this.hasPropertyListError = true;
        this.editEntry(e);
        this.$forceUpdate();
      };

      if (!newValue) {
        onError();
        this.globals.showErrorSnackbar(this.lang.SM2513);
        return;
      }

      for (let i = 0; i < values.length; i++) {
        if (i !== index && values[i].Value === newValue) {
          onError();
          this.globals.showErrorSnackbar(this.lang.SM2514);
          return;
        }
      }

      delete values[index].error;
      this.hasPropertyListError = false;
      this.$forceUpdate();
      e.target.readOnly = "true";
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  width: 60vw;
}
.modal-content {
  background-color: #eee;
}
.panel-body button.btn {
  padding: 8px;
}
.modal-footer > .btn-close {
  background-color: lightgray;
}

.btn-entry-actions {
  margin: 20px;
  width: 140px;
  height: 95px;
  white-space: normal;
}

.text-grey {
  color: grey;
}

#propertyListValuesTable input:read-only {
  cursor: pointer;
  background-image: none !important;
}

#propertyListValuesTableContainer {
  max-height: calc(100vh - 350px);
  overflow-y: auto;
}

#actionButtonContainer > .btn {
  padding: 0px;
  margin: 7px;
}

#propertyListValuesTable tr.error > td {
  background-color: #ff9999;
}
</style>



// WEBPACK FOOTER //
// CustomPropertyListEditModal.vue?26ec35c4